module.exports = __webpack_public_path__ + "img/img_userCase2.7a58e47d.png";